import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import KeyIssueViewItemDetails from "./KeyIssueViewItemDetails"
import RelatedInsightAreasViewWidget from "../../../common/RelatedInsightAreasViewWidget"
import PlaceholderImageViewWidget from "../../../common/PlaceholderImageViewWidget"
import ConceptMappingsViewWidget from "../../../common/concept-mappings/ConceptMappingsViewWidget"
import KeyIssuePermissionHoldersViewWidgetContainer from "./KeyIssuePermissionHoldersViewWidgetContainer"

const KeyIssueView = ({ model, isFetching }) => (
    <ItemDetailsColumns className="key-issue-item-container">
        <ItemDetailsColumn>
            <KeyIssueViewItemDetails
                name={model.name}
                subtitle={model.subtitle}
                description={model.description}
                status={model.status}
                imageUrl={model.image_url}
                isFetching={isFetching}
            />
            <div className="article-placeholders">
                <PlaceholderImageViewWidget
                    placeholders={model.placeholders}
                    isInheritEnabled={true}
                    isInheritingPlaceholders={model.inherit_placeholders}
                    inheritFrom={model.primary_topic}
                    isFetching={isFetching}
                />
            </div>
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <RelatedInsightAreasViewWidget
                primaryTopic={model.primary_topic}
                relatedTopics={model.topics}
                isFetching={isFetching}
            />
            <div id="keys-mappings">
                <ConceptMappingsViewWidget
                    mappings={model.mappings}
                    isFetching={isFetching}
                />
            </div>
            <div className="permission-holders">
                <KeyIssuePermissionHoldersViewWidgetContainer />
            </div>
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default KeyIssueView
